import { render, staticRenderFns } from "./PaoListTabs.vue?vue&type=template&id=5a02cffc&scoped=true"
import script from "./PaoListTabs.vue?vue&type=script&lang=js"
export * from "./PaoListTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02cffc",
  null
  
)

export default component.exports